import React, { Component ,Fragment } from 'react';
import Map from './Map';
import './style.css';
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
  Circle
} from "react-google-maps";


const data = [
  {
    id: 1,
    name: "Park Slope",
    latitude: "40.6710729",
    longitude: "-73.9988001",
    radius:3000
  },
  {
    id: 2,
    name: "Bushwick",
    latitude: "40.6942861",
    longitude: "-73.9389312",
    radius:2000
  },
  {
    id: 3,
    name: "East New York",
    latitude: "40.6577799",
    longitude: "-73.9147716",
    radius:1000
  }
];


for(var i=0;i<data.length;i++){
  data[i].circle = {
  radius:data[i].radius,
 
};
}
 class MyMap extends React.Component {

render(){

    const MapWithAMarker = withScriptjs(withGoogleMap(props =>
        <GoogleMap
            center={{ lat: 40.64, lng: -73.96 }}
              zoom={12}
              places={data}
               // defaultZoom={props.zoom}
               // defaultCenter={props.center}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo"
               loadingElement={<div style={{ height: `100%` }} />}
               containerElement={<div style={{ height: `800px` }} />}
               mapElement={<div style={{ height: `100%` }} />}
              >
               {data.map(place => {
                  return (
                    <Fragment key={place.id}>
                      <Marker
                        position={{
                          lat: parseFloat(place.latitude),
                          lng: parseFloat(place.longitude)
                        }}
                        
                      />
                      {place.circle && <Circle
                        defaultCenter={{
                          lat: parseFloat(place.latitude),
                          lng: parseFloat(place.longitude)
                        }}
                        radius={place.circle.radius}
                        options={place.circle.options}
                      />}
                    </Fragment>
                  );
                })}
              </GoogleMap>
              ));


    return (
    <div style={{marginTop:'200px'}}>
     <MapWithAMarker
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `400px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>)
}
 


}

export default MyMap